export default {
  MuiTextField: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      height: 'auto',
    },
  },
};
